// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Plaintext';



// WEBPACK FOOTER //
// ./components/Plaintext/index.js